export default __webpack_public_path__ + "static/media/AdobeStock_225711055.bcef1379.jpg";